<template>
	<div class="page">
		<div
			class="map_wrap"
			ref="map_wrap"
		>
			<img
				src="../assets/map_hastext.png"
				alt=""
			>
		</div>
		<div
			class="form_wrap"
			v-if="curpos&&!selectName"
		>
			<input
				name="id"
				type="text"
				v-model="areaid"
				placeholder="id"
			>
			<br>
			<input
				name="area"
				v-model="areaname"
				placeholder="区域名"
				type="text"
			>
			<button @click="add">添加</button>
			<button @click="slectCity">选择城市</button>
			<button @click="reset">重选</button>
		</div>
	</div>
</template>
<script>

export default {
	data() {
		return {
			pos: {},
			curpos: null,
			areaPos: null,
			selectName: false,
			areaname: "",
			areaid: "",
		};
	},
	created() {
		if (localStorage.getItem("area")) {
			this.pos = JSON.parse(localStorage.getItem("area"));
		}
	},
	methods: {
		renderPos() {
			$(".dock").remove();
			for (var i in this.pos) {
				let dock = document.createElement("div");
				let pointPos = this.pos[i]["pointPos"];
				dock.className = "dock";
				dock.style.left = pointPos.x + "px";
				dock.style.top = pointPos.y + "px";
				this.$refs.map_wrap.appendChild(dock);
			}
		},
		add() {
		
			if (this.curpos && this.areaPos && this.areaid && this.areaname) {
				this.pos[this.areaid] = {
					name: this.areaname,
					pointPos: this.curpos,
					namePos: this.areaPos,
				};
				this.reset();
				console.log(this.pos);
				localStorage.setItem("area", JSON.stringify(this.pos));
				this.renderPos();
			} else {
				alert("数据不能我i空");
			}
		},
		reset() {
			this.curpos = null;
			this.areaPos = null;
			this.selectName = false;
			this.areaname = "";
			this.areaid = "";
		},
		slectCity() {
			this.selectName = true;
		},
	},
	mounted() {
		this.renderPos();
		$(this.$refs.map_wrap).click((e) => {
			console.log(e);
			var curpos = { x: e.offsetX, y: e.offsetY };
			if (this.selectName) {
				this.areaPos = curpos;
				this.selectName = false;
			} else {
				this.curpos = curpos;
			}
		});
	},
};
</script>
<style>
.map_wrap {
	position: relative;
	width: 4000px;
	height: 4000px;
}
.dock {
	width: 10px;
	height: 10px;
	background: rgba(255, 255, 255, 200);
	position: absolute;
	z-index: 10;
}
</style>
<style lang="less" scoped>
.page {
	width: 100%;
	height: 100%;
	overflow: auto;
}
.form_wrap {
	position: absolute;
	left: 0;
	top: 0;
	z-index: 10;
	width: 100%;
	height: 100%;
	background: rgb(0, 0, 0);
}
</style>